// extracted by mini-css-extract-plugin
export default {"root":"JMv0Zx","price":"Axo2Wr","saleOn":"Q3PF1_","selectPrimary":"WWJqoJ","highlightTitle":"PBVgh3","tax":"prNEQB","bottom":"TyQgUg"};